// [hard code][hardcoded][하드코딩][하드 코딩] 하드코딩 관련 하드코드
// 예약판매 관리, 예약 판매 관리, 예약상품 관리, 예약 상품 관리
export const RESERVE_PRODUCTS = [
  /* 한진으로 입고 완료*/
  // {
  //   id: 20081805,
  //   name: '실리콘 무드등 - 다이버 빈',
  //   reserve_date: new Date('2024-11-11 00:00:00 GMT+0900'),
  // },
  // {
  //   id: 20081792,
  //   name: '인형 키링 - 다이버 빈',
  //   reserve_date: new Date('2024-12-02 00:00:00 GMT+0900'),
  // },
  // {
  //   id: 20081743,
  //   name: '스트레스 볼 - 다이버 빈',
  //   reserve_date: new Date('2024-12-02 00:00:00 GMT+0900'),
  // },
  {
    id: 23293005,
    name: '[2차 예약 판매][BA X 바이시클] 플레잉카드',
    reserve_date: new Date('2026-05-05 00:00:00 GMT+0900'), // 예약 판매 기간 fix 되면 해당 날짜로 변경 요망
  },
  {
    id: 22926660,
    name: '[예약 판매][BA X 바이시클] 플레잉카드',
    reserve_date: new Date('2026-05-05 00:00:00 GMT+0900'), // 예약 판매 기간 fix 되면 해당 날짜로 변경 요망
  },
];
